import { defaultIconProps } from 'config/constants.config'
import { Moon, Sparkles, Sun } from 'lucide-react'

export const ThemesIcons = {
    light: (props: React.ComponentProps<typeof Sun>) => <Sun {...defaultIconProps} {...props} />,
    dark: (props: React.ComponentProps<typeof Moon>) => <Moon {...defaultIconProps} {...props} />,
    system: (props: React.ComponentProps<typeof Sparkles>) => <Sparkles {...defaultIconProps} {...props} />,
}
